var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon, _rect, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#125ba8;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#04830a;}.cls-3{fill:#f0a631;}.cls-4{fill:#004d93;}.cls-5{fill:#f49938;}.cls-6{fill:#f39938;}.cls-7{fill:#199d47;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.9,4.9l-3.2,9.7.8.1L20.7,5Zm-3.2,9.7V15l.1.1.1.1a.37.37,0,0,0,.3-.1c.1-.1.2-.2.2-.3Zm4-9.5V4.7l-.1-.1-.1-.1a.37.37,0,0,0-.3.1c-.1.1-.2.2-.2.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.4,9.1l-8.6,5.3.3.7,8.6-5.3Zm-8.5,5.3c-.1.1-.2.2-.2.3V15l.1.1.1.1h.2c.1,0,.1,0,.1-.1Zm8.9-4.6c.1-.1.2-.2.2-.3V9.2l-.1-.1L25.8,9h-.2c-.1,0-.1,0-.1.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.1,10.4l-8.6,5.3.5.6L26.6,11Zm-8.6,5.4-.1.1-.1.1v.2c0,.1,0,.1.1.1s.2.1.3.2a.37.37,0,0,0,.3-.1Zm9.1-4.7.1-.1.1-.1v-.2c0-.1,0-.1-.1-.1s-.2-.1-.3-.2a.37.37,0,0,0-.3.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.6,17.2l-9.9-1.5-.2.8L27.4,18Zm-9.9-1.5a.37.37,0,0,0-.3.1c-.1.1-.2.2-.2.3v.2c0,.1,0,.1.1.1a.1.1,0,0,1,.1.1h.2ZM27.5,18a.37.37,0,0,0,.3-.1c.1-.1.2-.2.2-.3v-.2c0-.1,0-.1-.1-.1l-.1-.1h-.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.3,18.7l-10-1.5V18l10,1.5Zm-10-1.5h-.2c-.1,0-.1,0-.1.1l-.1.1v.2c0,.1.1.2.1.3s.2.1.3.2Zm10,2.3h.2c.1,0,.1,0,.1-.1l.1-.1v-.2c0-.1-.1-.2-.1-.3s-.2-.1-.3-.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.2,24.9l-6.7-7.6-.6.5,6.7,7.6Zm-6.7-7.6c-.1-.1-.2-.1-.3-.2a.37.37,0,0,0-.3.1l-.1.1v.4a.1.1,0,0,0,.1.1Zm6,8.1c.1.1.2.1.3.2a.37.37,0,0,0,.3-.1l.1-.1V25c0-.1,0-.1-.1-.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,25.8l-6.7-7.7-.5.6,6.7,7.7Zm-6.7-7.7-.1-.1h-.4a.1.1,0,0,0-.1.1.37.37,0,0,0-.1.3c0,.1.1.2.1.3Zm6.2,8.3.1.1H23a.1.1,0,0,0,.1-.1.37.37,0,0,0,.1-.3c0-.1-.1-.2-.1-.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.7,28.6l-.3-10.2-.8-.1.3,10.2Zm-.3-10.2a.37.37,0,0,0-.1-.3c-.1-.1-.2-.1-.3-.2h-.2l-.1.1-.1.1v.2Zm-.5,10.1a.37.37,0,0,0,.1.3c.1.1.2.1.3.2h.2l.1-.1.1-.1v-.2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.2,28.5,15,18.3l-.8.1.2,10.2Zm-.3-10.2v-.2c0-.1,0-.1-.1-.1l-.1-.1h-.2c-.1,0-.2.1-.3.2a.37.37,0,0,0-.1.3Zm-.5,10.3v.2c0,.1,0,.1.1.1l.1.1h.2c.1,0,.2-.1.3-.2a.37.37,0,0,0,.1-.3Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.6,26.5l6.3-8-.6-.6L8,25.9Zm6.2-8a.5.5,0,0,0,0-.6l-.1-.1h-.2c-.1,0-.1,0-.2.1l-.1.1ZM8,25.9a.5.5,0,0,0,0,.6l.1.1h.2c.1,0,.1,0,.2-.1l.1-.1Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.5,25.4l6.3-8-.7-.4L6.8,25Zm6.3-8,.1-.1v-.2c0-.1,0-.1-.1-.2l-.1-.1a.19.19,0,0,0-.3,0c-.1,0-.2.1-.3.2ZM6.8,25l-.1.1v.2c0,.1,0,.1.1.2l.1.1a.19.19,0,0,0,.3,0c.1,0,.2-.1.3-.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.7,19.6l9.9-2-.1-.8-9.9,2Zm9.9-2.1c.1,0,.2-.1.3-.2s.1-.2.1-.3,0-.1-.1-.2l-.1-.1a.1.1,0,0,1-.1-.1h-.2ZM3.7,18.8c-.1,0-.2.1-.3.2a.37.37,0,0,0-.1.3c0,.1,0,.1.1.2l.1.1a.1.1,0,0,1,.1.1h.2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.6,18.1l9.9-2-.3-.8-9.9,2Zm9.9-2c.1,0,.1,0,.2-.1l.1-.1a.31.31,0,0,1,.1-.2v-.2c0-.1-.1-.2-.2-.3a.19.19,0,0,0-.3,0ZM3.3,17.3c-.1,0-.1,0-.2.1l-.1.1a.31.31,0,0,1-.1.2v.2c0,.1.1.2.2.3a.19.19,0,0,0,.3,0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.4,11.1,13.2,16l.4-.7L4.8,10.4ZM13.2,16a.37.37,0,0,0,.3.1c.1,0,.2-.1.3-.2a.31.31,0,0,1,.1-.2v-.2c0-.1,0-.1-.1-.1l-.1-.1ZM4.8,10.5a.37.37,0,0,0-.3-.1c-.1,0-.2.1-.3.2a.31.31,0,0,1-.1.2c-.1.1,0,.1,0,.2s0,.1.1.1l.1.1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.2,9.9,14,14.8l.3-.8L5.5,9.1Zm8.9,4.9.1.1h.2c.1,0,.1,0,.1-.1l.1-.1v-.3c0-.1-.1-.2-.2-.3ZM5.5,9.1,5.4,9H5.2c-.1,0-.1,0-.1.1s-.1.1-.1.2v.3c0,.1.1.2.2.3Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.2,5.1l3.7,9.5.8-.2L11,4.9Zm3.7,9.5c0,.1.1.2.2.3a.37.37,0,0,0,.3.1c.1,0,.1,0,.1-.1l.1-.1v-.4ZM11,4.9c0-.1-.1-.2-.2-.3a.37.37,0,0,0-.3-.1c-.1,0-.1,0-.1.1l-.1.1v.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.7,4.7l3.7,9.5.7-.4L12.4,4.3Zm3.6,9.5c0,.1,0,.1.1.1l.1.1h.4c.1-.1.2-.2.2-.3v-.3ZM12.4,4.3c0-.1,0-.1-.1-.1l-.1-.1h-.4c-.1.1-.2.2-.2.3v.3Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.6,4.3,15.4,14l.7.3,3.2-9.7ZM15.4,14v.3c0,.1.1.2.2.3H16l.1-.1.1-.1Zm3.9-9.4V4.3c0-.1-.1-.2-.2-.3h-.4l-.1.1-.1.1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.5,25a11.22,11.22,0,0,1-3.3,2,9.86,9.86,0,0,1-3.8.7,9.25,9.25,0,0,1-2.9-.4,12,12,0,0,1-2.6-1.1,12.82,12.82,0,0,1-2.2-1.7A8.68,8.68,0,0,1,65,22.3a8.49,8.49,0,0,1-1.1-2.6,9.25,9.25,0,0,1-.4-2.9,9.25,9.25,0,0,1,.4-2.9A15.33,15.33,0,0,1,65,11.2,12.82,12.82,0,0,1,66.7,9a8.68,8.68,0,0,1,2.2-1.7,8.49,8.49,0,0,1,2.6-1.1,9.25,9.25,0,0,1,2.9-.4,9.86,9.86,0,0,1,3.8.7,10.07,10.07,0,0,1,3.3,2l-2.3,3.7A6.91,6.91,0,0,0,77,10.6a6.46,6.46,0,0,0-2.7-.5,8.57,8.57,0,0,0-2.7.5,7.82,7.82,0,0,0-2.2,1.5,7.12,7.12,0,0,0-1.5,2.2,5.92,5.92,0,0,0-.5,2.7,7.08,7.08,0,0,0,.5,2.6,7.82,7.82,0,0,0,1.5,2.2,7.12,7.12,0,0,0,2.2,1.5,5.92,5.92,0,0,0,2.7.5,8.57,8.57,0,0,0,2.7-.5,6,6,0,0,0,2.2-1.6Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "43.1 5.5 51.3 18 51.3 27 55.6 27 55.6 18 63.8 5.5 58.4 5.5 53.6 14.4 48.4 5.5 43.1 5.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 36.8,
    y: 5.5,
    width: 4,
    height: 21.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M107.3,17V27h4.3V17Zm12.9,2.7L118.6,17H114l5.9,10h4.6V17h-4.3Zm0-14.1v10h4.3V5.6Zm-8.3,0h-4.6v10h4.3V13l1.5,2.6h4.6Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M141.3,19.7,139.7,17h-4.6L141,27h4.6V17h-4.3v2.7Zm0-14.1v10h4.3V5.6Zm-8.3,0h-4.6v10h4.3V13l1.5,2.6h4.6ZM128.4,27h4.3V17h-4.3Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.8,18.4h7V17H149.5V27h14.7V22.7H153.8ZM149.5,5.6v10h11.3V14.2h-7V9.8h10.4V5.6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.3,13.7a6.62,6.62,0,0,1,1.5-2.2A7.12,7.12,0,0,1,174,10a5.92,5.92,0,0,1,2.7-.5,8.57,8.57,0,0,1,2.7.5,6,6,0,0,1,2.2,1.6l2.3-3.7a11.22,11.22,0,0,0-3.3-2,9.86,9.86,0,0,0-3.8-.7,9.25,9.25,0,0,0-2.9.4,12,12,0,0,0-2.6,1.1,12.82,12.82,0,0,0-2.2,1.7,8.68,8.68,0,0,0-1.7,2.2,8.49,8.49,0,0,0-1.1,2.6,15.52,15.52,0,0,0-.4,2.1h4.3C169.9,14.9,170.1,14.3,170.3,13.7Zm9,8.9a6.46,6.46,0,0,1-2.7.5,8.57,8.57,0,0,1-2.7-.5,7.82,7.82,0,0,1-2.2-1.5,7.12,7.12,0,0,1-1.5-2.2,6.53,6.53,0,0,1-.5-2h-4.3a8.52,8.52,0,0,0,.4,2.3,12,12,0,0,0,1.1,2.6,12.82,12.82,0,0,0,1.7,2.2,8.68,8.68,0,0,0,2.2,1.7,8.49,8.49,0,0,0,2.6,1.1,9.25,9.25,0,0,0,2.9.4,9.86,9.86,0,0,0,3.8-.7,10.07,10.07,0,0,0,3.3-2l-2.3-3.7A2.7,2.7,0,0,1,179.3,22.6Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.3,27H191V9.8h-6.4V5.6h17.1V9.9h-6.4V27Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.8,17.1h2.7a2.71,2.71,0,1,1-2.6-3.5,2.79,2.79,0,0,1,2.7,2.1H74.9v1.4Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.9,26.9a.9.9,0,0,1-.6-.6,1.22,1.22,0,0,1-.3-.9h1c0,.1.1.3.1.4s.2.2.3.2.2.1.4.1a1.42,1.42,0,0,0,.6-.2.85.85,0,0,0,.2-.6v-.2a.85.85,0,0,0-.2-.6.76.76,0,0,0-.5-.2h-.5v-.9h.5a.52.52,0,0,0,.4-.2.76.76,0,0,0,.2-.5v-.1a.68.68,0,0,0-.7-.7.37.37,0,0,0-.3.1c-.1.1-.2.1-.2.2s-.1.2-.1.4h-1a1.61,1.61,0,0,1,.3-.9l.6-.6a1.88,1.88,0,0,1,.8-.2,1.59,1.59,0,0,1,1.2.4,1.5,1.5,0,0,1,.4,1.1v.1a2.35,2.35,0,0,1-.2.8c-.1.3-.4.4-.6.5a1.16,1.16,0,0,1,.7.5,1.22,1.22,0,0,1,.3.9v.1a2.92,2.92,0,0,1-.2.9,1.7,1.7,0,0,1-.6.6,2.92,2.92,0,0,1-.9.2A1.66,1.66,0,0,1,202.9,26.9Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.5,26h1v1h-1Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209,26.6a1.59,1.59,0,0,1-.4-1.2V22.7a1.46,1.46,0,0,1,.4-1.2,2.31,2.31,0,0,1,2.6,0,1.59,1.59,0,0,1,.4,1.2v2.7a1.46,1.46,0,0,1-.4,1.2,1.7,1.7,0,0,1-1.3.4A1.39,1.39,0,0,1,209,26.6Zm1.8-.7a1.45,1.45,0,0,0,.2-.7V22.8a1.45,1.45,0,0,0-.2-.7c-.1-.2-.3-.2-.6-.2a.85.85,0,0,0-.6.2,1.45,1.45,0,0,0-.2.7v2.4a1.45,1.45,0,0,0,.2.7c.1.2.3.2.6.2S210.7,26.1,210.8,25.9Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.41,8.61l2.29,2.3a9.27,9.27,0,0,0-.86,1.1c-1-.7-2-1.4-2.67-1.77Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.06,13.27l-.53.66L89,12.85a6.18,6.18,0,0,1,.72-.9Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.64,22.53a7.63,7.63,0,0,0,1.15.72c-.51,1.05-1,2.13-1.27,2.77l-1.74-.94,1.86-2.55Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.25,20.33s-.35.68-.8,1.59a5.69,5.69,0,0,1-1-.57l1-1.43Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.93,23.72A7.75,7.75,0,0,0,93.3,24c-.13,1.14-.24,2.29-.26,3l-2-.32Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.7,20.64s-.11.8-.23,1.85a5.88,5.88,0,0,1-1.11-.21l.53-1.79Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M87.9,20.65a7,7,0,0,0,.83,1.06L86.5,23.87l-1.22-1.54C85.89,22,86.92,21.31,87.9,20.65Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.06,19.45l-1.3,1.26a6.32,6.32,0,0,1-.7-.85l1.48-1Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.87,18.38a7.81,7.81,0,0,0,.47,1.28l-2.89,1.42-.64-1.9C84.51,19,85.72,18.71,86.87,18.38Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.24,18.24l-1.64.81A5.64,5.64,0,0,1,88.2,18L90,17.47Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.59,16.29c0,.28,0,.55,0,.81l-3.3.37,0-2c.74.11,2,.22,3.25.3C86.6,15.93,86.59,16.11,86.59,16.29Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.73,16.76,88,17c0-.21,0-.41,0-.62a3.93,3.93,0,0,1,0-.49l1.73.09Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.54,8.55a6.9,6.9,0,0,0-1.37.25l-.72-3,2-.27C93.42,6.26,93.47,7.41,93.54,8.55Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.79,12,93,12.1l-.43-1.78a5.62,5.62,0,0,1,1.1-.18Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.89,9.29a7.39,7.39,0,0,0-1.2.73L87.85,7.39l1.8-.95C89.9,7.11,90.39,8.21,90.89,9.29Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.35,12.35l-.74.41-1-1.5a5.74,5.74,0,0,1,1-.58C92,11.64,92.35,12.35,92.35,12.35Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.31,11.86c.64.35,1.79.87,2.9,1.36a7.41,7.41,0,0,0-.42,1.31l-3.23-.78Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.18,14.5l-.29.78-1.74-.42a6.41,6.41,0,0,1,.36-1.07Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.88,23.93l-2.31-2.28a8.36,8.36,0,0,0,.85-1.11c1,.69,2,1.39,2.69,1.75Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.19,19.3l.52-.66s.65.47,1.52,1.07a6.25,6.25,0,0,1-.71.9Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.54,10a8.63,8.63,0,0,0-1.16-.72c.5-1.05,1-2.13,1.24-2.78l1.75.93L98.54,10Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96,12.26l.79-1.6a7,7,0,0,1,1,.56l-1,1.44Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.23,8.87a6.84,6.84,0,0,0-1.36-.28c.12-1.14.22-2.3.23-3l2,.3Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.49,12s.1-.8.22-1.86a6.8,6.8,0,0,1,1.11.21l-.51,1.79Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100.3,11.9a7.8,7.8,0,0,0-.85-1.05l2.22-2.18,1.23,1.53C102.29,10.55,101.27,11.23,100.3,11.9Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M97.14,13.13l1.29-1.27a6.31,6.31,0,0,1,.71.84l-1.48,1.05Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.34,14.16a7.31,7.31,0,0,0-.48-1.28l2.88-1.44.66,1.89C103.69,13.48,102.49,13.82,101.34,14.16Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98,14.33l1.63-.82a6,6,0,0,1,.4,1.05l-1.75.54Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.63,16.25a7.09,7.09,0,0,0,0-.81l3.3-.39,0,2c-.73-.1-2-.2-3.25-.27A4.64,4.64,0,0,0,101.63,16.25Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.49,15.81l1.73-.21q0,.32,0,.63c0,.16,0,.32,0,.48l-1.74-.08Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.75,24a6.9,6.9,0,0,0,1.37-.25l.75,2.95-2,.28C94.9,26.34,94.83,25.18,94.75,24Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.47,20.63l.81-.13.45,1.77a5.62,5.62,0,0,1-1.1.19C94.54,21.41,94.47,20.63,94.47,20.63Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.4,23.29a7,7,0,0,0,1.19-.75l1.86,2.62-1.79,1C98.41,25.46,97.9,24.36,97.4,23.29Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.91,20.24l.74-.42,1.06,1.5a6,6,0,0,1-1,.58C96.27,21,95.91,20.24,95.91,20.24Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M104,20.66c-.65-.34-1.8-.86-2.91-1.34a7.11,7.11,0,0,0,.4-1.31l3.23.76Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M98.06,18.07l.29-.78,1.74.41a5.58,5.58,0,0,1-.35,1.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01);
export default __webpack_public_path__ + "static/media/logo-01.341f92d960ff900995e4f4e6601e5da9.svg";
export { ForwardRef as ReactComponent };